import { useEffect } from 'react'
import { readGrantMirror } from '../../lib/grantMirror'
import { readOrganizerCanvass } from '../../lib/organizerCanvass'
import { syncEngine } from '../../lib/syncEngine'

/**
 * [Canvass this, CT-12] While the organizer is in organizer mode with a set-aside grant session, keep
 * its offline queue draining. Renders null. Mounted in RequireAuth; CanvasserLayout's SyncProvider
 * lives under RequireGrant, so the two never co-mount (the engine is a singleton).
 */
export function SetAsideGrantSync() {
  useEffect(() => {
    const marker = readOrganizerCanvass()
    const mirror = readGrantMirror()
    if (!marker || !mirror || marker.grantId !== mirror.grantId) return
    let cancelled = false
    void (async () => {
      try {
        await syncEngine.init()
        if (cancelled) return
        // [R5/R4] countPending = queued visits + this grant's queued drop-offs and calls (an outcome- or call-only queue drains too).
        if (navigator.onLine && (await syncEngine.countPending()) > 0) await syncEngine.sync()
      } catch {
        // best-effort: failures never surface in organizer mode
      }
    })()
    return () => {
      cancelled = true
      syncEngine.destroy()
    }
  }, [])

  return null
}
